import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    unlisten: () => void = undefined; // 关闭侦听函数
    visitedList: any[]; // f最近访问记录list
}


// WEBPACK FOOTER //
// ./src/display/components/RecentlyVisited/Modules.State.ts